import React, { useEffect } from "react";
import "./MediaPageLoader.css";

const MediaPageLoader = ({ show }) => {
  useEffect(() => {
    if (!show) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [show]);

  if (!show) return null;

  return (
    <div
      className="media-page-loader"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <span className="media-page-loader-sr">Loading page content</span>
      <div className="media-page-loader-spinner" aria-hidden />
    </div>
  );
};

export default MediaPageLoader;
